import React, { Component } from "react";
import Slider from "react-slick";
import FadeIn from "react-lazyload-fadein";
import { Link } from 'react-router-dom';

export default class Gallery extends Component {
	
	constructor(props) {
    	super(props);
    }
  	
	componentDidMount() {
		setTimeout(() => {
			if (document.getElementsByClassName('slick-cover').length > 0) {
				document.getElementsByClassName('slick-cover')[0].classList.add('state-inactive');
			}
		}, 2000);
		setTimeout(() => {
			if (window.document.getElementsByClassName('slick-prev').length > 0) {
				window.document.getElementsByClassName('slick-prev')[0].addEventListener('mouseover', function(){
					document.documentElement.classList.add('state-prev-hover');
				});
				window.document.getElementsByClassName('slick-prev')[0].addEventListener('mouseout', function(){
					document.documentElement.classList.remove('state-prev-hover');
				});
				window.document.getElementsByClassName('slick-next')[0].addEventListener('mouseover', function(){
					document.documentElement.classList.add('state-next-hover');
				});
				window.document.getElementsByClassName('slick-next')[0].addEventListener('mouseout', function(){
					document.documentElement.classList.remove('state-next-hover');
				});
			}
		}, 500);
	}
  			
	render() {
		
		let gallery = this.props.gallery;
		
		if (gallery) {
	    	const settings = {
				dots: false,
				arrows: true,
				infinite: false,
				speed: 500,
				slidesToShow: 1,
				slidesToScroll: 1
			};
			
			const slides = gallery.map((slide,i) =>
				{
					return (
						<div className="inner" key={i}>
							{slide.srcset &&
								<FadeIn>
									{onload => (
										<img
											alt={''} 
											src={slide.src} 
											srcSet={slide.srcset} 
											onLoad={onload}
										/>
									)}
								</FadeIn>
							}
							{!slide.srcset &&
								<FadeIn>
									{onload => (
										<img
											alt={''} 
											src={slide.src} 
											onLoad={onload}
										/>
									)}
								</FadeIn>
							}
						</div>
					)
				}
			);

			return (				
				
				<div className={'scope-slick scope-slick--' + gallery.length}>
					<div>
						<Slider {...settings}>
							{slides}
						</Slider>
					</div>
				</div>
									
			);
			
		} else {
			return null;
		}
	}
}